module.exports = __webpack_public_path__ + "static/img/wait.9c30bf2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wait.png
// module id = pNDR
// module chunks = 1